import { Empty, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { isLoadFailed } from './useVinRequest';
import VinLoadError from './VinLoadError';
import BatchesTable from './BatchesTable';

/** First load → skeleton; a failed or unreadable answer → error with Retry; nothing on page 1 → empty; else the table. */
const BatchesBody = ({ batches, refreshToken, settings }) => {
    const { t } = useTranslation('vinExtraction');
    const { load, run, page, query, changeQuery } = batches;

    if (load.status === 'loading' && !load.data) return <Skeleton active paragraph={{ rows: 6 }} />;
    if (isLoadFailed(load)) {
        return (
            <VinLoadError
                status={load.status}
                error={load.error}
                message={t('batches.loadFailed')}
                invalidDescription={t('batches.invalidResponse')}
                onRetry={run}
            />
        );
    }
    if (!load.data.items.length && page === 1) return <Empty description={t('batches.empty')} />;

    return (
        <BatchesTable
            data={load.data}
            loading={load.status === 'loading'}
            page={page}
            pageSize={query.pageSize}
            refreshToken={refreshToken}
            settings={settings}
            onPageChange={changeQuery}
        />
    );
};

export default BatchesBody;
